import React from 'react';
import i18n from 'i18n-react';
import { RefinementList, ClearRefinements } from 'react-instantsearch-hooks-web';

const SearchFilters = (hitTypes) => {
  const filters = (hitTypes) => {
    if (hitTypes.hitTypes === 'sales_companion_items' || hitTypes.hitTypes === 'links') {
      return (
        <div className="filters">
          <div className="filterTitle">
            <p>
              {hitTypes.hitTypes === 'sales_companion_items'
                ? i18n.translate('filters.SCI')
                : i18n.translate('filters.links')}
            </p>
          </div>
          <RefinementList attribute="type" />
          <ClearRefinements excludedAttributes={[]} />
        </div>
      );
    }
    return null;
  };
  return filters(hitTypes);
};

export default SearchFilters;
